import type { LessonProgress } from './api'

export type LessonState = 'done' | 'started' | 'new'

export function lessonState(progress: LessonProgress | undefined): LessonState {
  if (progress?.completed_at) return 'done'
  if (progress) return 'started'
  return 'new'
}
